var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { BehaviorSubject } from 'rxjs';
import { useObservable } from 'botparade';
var toastStream = new BehaviorSubject([]);
export function pushToast(toast) {
    toastStream.next(__spreadArray(__spreadArray([], toastStream.getValue()), [toast]));
}
export var ToastList = function () {
    var toasts = useObservable(toastStream) || [];
    function handleClose(toast) {
        toastStream.next(toastStream.getValue().filter(function (t) { return t !== toast; }));
    }
    return (React.createElement("div", { className: "ToastList p-3" }, toasts.map(function (toast, index) {
        return React.createElement("div", { key: index, className: "toast show", role: "alert", "aria-live": "assertive", "aria-atomic": "true" },
            React.createElement("div", { className: "toast-header" },
                React.createElement("strong", { className: "mr-auto" }, toast.title),
                React.createElement("button", { type: "button", className: "ml-2 mb-1 close", "data-dismiss": "toast", "aria-label": "Close", onClick: function () { handleClose(toast); } },
                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
            React.createElement("div", { className: "toast-body" }, toast.body));
    })));
};
